export const API_BASE = "https://xiadot.com/vendor_api";

export async function apiFetch(path, opts = {}) {
  const { method = "GET", token = "", body = null, headers = {} } = opts;

  const isFormData = body instanceof FormData;

  const res = await fetch(API_BASE + path, {
    method,
    headers: {
      // ✅ FormData என்றால் Content-Type set பண்ணக்கூடாது
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...(token ? { Authorization: "Bearer " + token } : {}),
      ...headers,
    },
    ...(body ? { body: isFormData ? body : JSON.stringify(body) } : {}),
  });

  const text = await res.text();

  let data = {};
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    throw new Error("Backend not returning JSON: " + text.slice(0, 200));
  }

  if (!res.ok || data?.success === false) {
    throw new Error(data?.message || data?.error || "API Error");
  }

  return data;
}